// extracted by mini-css-extract-plugin
export default {"wordListPageContent":"WordListPageContent_wordListPageContent__iwy7+","searchContainer":"WordListPageContent_searchContainer__KWsAs","wordList":"WordListPageContent_wordList__Gl367"};